import {SearchError} from './SearchError.js'

export class InvalidRequestSearchError extends SearchError {}
